<template>
  <div class="app-container">
    <PageTitle title="角色列表" :city_show="false" />
    <div class="filter-container" style="justify-content: start">
      <el-input
        v-model="listQuery.name"
        clearable
        class="filter-item"
        style="width: 180px"
        placeholder="角色名称"
        @keyup.enter.native="handleFilter"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        搜索
      </el-button>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="$refs.editDialog.handleCreate()"
      >
        添加角色
      </el-button>
    </div>

    <Table :data="list" :columns="columns" :loading="listLoading">
      <template v-slot:permissions>
        <el-table-column label="导航权限" min-width="360" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ permissionLabels(scope.row.permission_keys).join('、') }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:action>
        <el-table-column label="操作" width="170">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="$refs.editDialog.handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)"> 删除 </el-button>
          </template>
        </el-table-column>
      </template>
    </Table>

    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
    <Edit ref="editDialog" :permission-options="permissionOptions" @saved="fetchData" />
  </div>
</template>

<script>
import { del, getList, getPermissionOptions } from '@/api/roles'
import PageTitle from '@/components/PageTitle'
import Edit from './components/Edit'

export default {
  name: 'RolesIndex',
  components: { Edit, PageTitle },
  data() {
    return {
      list: [],
      count: 0,
      listLoading: false,
      permissionOptions: [],
      permissionLabelMap: {},
      listQuery: { page: 1, size: 10, name: '' },
      columns: [
        { type: 'index', label: '序号', width: '70', align: 'center' },
        { label: '角色名称', prop: 'name', width: '180' },
        { label: '导航权限', slot: 'permissions' },
        { label: '绑定管理员', prop: 'admin_count', width: '110', align: 'center' },
        { label: '创建时间', prop: 'add_time', width: '180' },
        { label: '操作', slot: 'action' }
      ]
    }
  },
  created() {
    getPermissionOptions().then((res) => {
      this.permissionOptions = res.data
      const visit = (items) =>
        items.forEach((item) => {
          this.$set(this.permissionLabelMap, item.key, item.label)
          if (item.children) visit(item.children)
        })
      visit(res.data)
    })
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.listLoading = true
      getList(this.listQuery)
        .then((res) => {
          this.list = res.data.results
          this.count = res.data.count
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    permissionLabels(keys) {
      return (keys || []).map((key) => this.permissionLabelMap[key] || key)
    },
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
    handleDelete(role) {
      this.$confirm(`确定删除角色“${role.name}”吗？`, '删除角色', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => del(role.id))
        .then(() => {
          this.$notify({ title: '成功', message: '角色已删除', type: 'success' })
          this.fetchData()
        })
        .catch(() => {})
    }
  }
}
</script>
